@import '../../../../app-brand/entities/entity-layer.module.less';
@import '../../../../constants/spacing.module.less';

.no-tags-message {
  font-style: italic;
  text-align: center;
  color: @orders-drawer--default--text-color;
}

.tags-container {
  display: flex;
  flex-flow: row wrap;
  gap: @space-8;
}
